/**
 * Chart chrome for Reports light panels (PageLayout / reportsLightCard).
 * Dark-panel Home charts keep their own theme; do not reuse these on blue KPIs.
 */
export const REPORTS_CHART_AXIS = '#475569'
export const REPORTS_CHART_GRID = 'rgba(15, 23, 42, 0.1)'
export const REPORTS_CHART_AXIS_LINE = '#94a3b8'

export const reportsChartTick = { fontSize: 11, fill: REPORTS_CHART_AXIS }
export const reportsChartAxisStroke = REPORTS_CHART_AXIS_LINE
